import { FastlyImage, LazyImage } from '@components/common/image'
import { BenefitDataType } from '@lib/data/teacher-lp'

type TextAlignmentType =
  | 'text-left'
  | 'text-center'
  | 'text-right'
  | 'text-justify'
type IconAlignment =
  | 'items-start'
  | 'items-baseline'
  | 'items-center'
  | 'items-end'
  | 'items-stretch'

type Props = {
  data: BenefitDataType[]
  imagePath: string
  heading: string
  iconAlignment: IconAlignment
  titleAlignment: TextAlignmentType
  descriptionAlignment: TextAlignmentType
}

const Card = ({
  data,
  imagePath,
  heading,
  iconAlignment,
  titleAlignment,
  descriptionAlignment,
}: Props) => (
  <>
    <div className="flex flex-col items-center justify-center pt-6 pb-3">
      <p className="font-700 text-3xl md:text-4xl text-center md:text-left text-grey-900 leading-10 px-4">
        {heading}
      </p>
      <LazyImage
        path="/images/teacher-lp/"
        name="line"
        className="w-24 md:w-32"
        alt="line image"
      />
    </div>

    <div className="grid md:grid-cols-4 gap-4 md:gap-2 pt-6 md:pt-12 px-4 md:px-10 container mx-auto">
      {data.map((benefit) => (
        <div
          key={benefit.title}
          className="rounded-lg bg-white"
          style={{
            filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1))',
          }}
        >
          <div
            className={`px-8 py-12 md:px-6 md:py-8 flex flex-col h-full ${iconAlignment}`}
          >
            <FastlyImage
              src={`${imagePath}${benefit.icon}.png`}
              alt={`${benefit.title} icon`}
              height="70"
              width="60"
            />
            <p
              className={`font-700 text-grey-900 text-2xl py-3 leading-7 ${titleAlignment}`}
            >
              {benefit.title}
            </p>
            <p
              className={`text-grey-800 text-xl leading-7 ${descriptionAlignment}`}
            >
              {benefit.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </>
)

export default Card
